import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { TermsFormValues } from "../../../types/PitchTypes/PitchTypes";

interface useGetTermsRequestsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetMITerms({
  userId,
  enabled = true,
}: useGetTermsRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ["muslim-invest-terms", userId],
    queryFn: async () => {
      return axiosInstance<TermsFormValues[]>(
        getAPIURL(`/MuslimInvestProfile/Terms/by-user/${userId}`)
      ).then((response) => response.data);
    },
  });
}
